module.exports = __webpack_public_path__ + "static/media/emma_s1.b392bd5e.png";